import { server_ip } from "../config";

async function postReqestOTP(phone){
    try{
        const res = await fetch(`${server_ip}/api/users/requestotp`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                mobile: phone,
            })
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function postLoginOTP(phone, otp){
    try{
        const res = await fetch(`${server_ip}/api/users/loginWithOtp`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                mobile: phone,
                otp
            })
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function getUserInfo(token){
    try{
        const res = await fetch(`${server_ip}/api/users/profile`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function postSelectCata(token, category){
    try{
        const res = await fetch(`${server_ip}/api/users/selectCategory`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                category
            })
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function postProgress(token, payload, progress){
    try{
        const res = await fetch(`${server_ip}/api/users/progress`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                payload,
                progress
            })
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function getRedeemAvailibity(token){
    try{
        const res = await fetch(`${server_ip}/api/redeems/available`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function insertRedirectRecords(link){
    try{
        const res = await fetch(`${server_ip}/api/redirects`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data:{link}
            })
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}


async function clickIg(token){
    try{
        const res = await fetch(`${server_ip}/api/users/click/ig`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}
async function clickFacebook(token){
    try{
        const res = await fetch(`${server_ip}/api/users/click/facebook`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
        return res.json()
    }catch(error){
        console.log(JSON.stringify(error));
        return { errno: 1, message: error?.message || 'unknown error' }
    }
}

export{
    postReqestOTP,
    postLoginOTP,
    getUserInfo,
    postSelectCata,
    postProgress,
    getRedeemAvailibity,
    insertRedirectRecords,
    clickIg,
    clickFacebook,
}